export default __webpack_public_path__ + "static/media/navbar-pricing-dark.eefaec11.svg";